import { Injectable } from '@angular/core';
import { JeevesOrderListConfigService } from 'gung-standard-jeeves';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColmecLastOrderListConfigService extends JeevesOrderListConfigService {
  getItems() {
    return super.getItems().pipe(map(data => data.sort((a, b) => (a.id > b.id ? -1 : 1)).slice(0, 5)));
  }

  getFilters() {
    return [];
  }

  getNothingFoundTranslateTag() {
    return null;
  }

  getSearchGroupCss() {
    return 'd-none';
  }

  getFilterGroupCss() {
    return 'd-none';
  }
}
